import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

export type AttachmentPreviewSource = {
  kind: 'image' | 'video';
  url: string;
  name: string;
};

interface AttachmentPreviewProps {
  source: AttachmentPreviewSource | null;
  onClose: () => void;
}

export function AttachmentPreview({ source, onClose }: AttachmentPreviewProps): JSX.Element | null {
  useEffect(() => {
    if (!source) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [source, onClose]);

  if (!source) return null;
  return createPortal(
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/85 p-4 backdrop-blur-sm" onClick={onClose}>
      <div className="relative flex max-h-[92vh] w-full max-w-5xl flex-col" onClick={(event) => event.stopPropagation()}>
        <div className="mb-2 flex min-h-8 items-center justify-between gap-3 px-1">
          <p className="min-w-0 truncate text-sm text-white/85">{source.name}</p>
          <button onClick={onClose} className="rounded-md bg-white/10 p-1.5 text-white/80 hover:bg-white/20" title="关闭预览">
            <X size={18} />
          </button>
        </div>
        <div className="flex min-h-0 flex-1 items-center justify-center overflow-hidden rounded-lg bg-black">
          {source.kind === 'image' ? (
            <img src={source.url} alt={source.name} className="max-h-[86vh] max-w-full object-contain" />
          ) : (
            <video src={source.url} controls autoPlay playsInline preload="metadata" className="max-h-[86vh] max-w-full" />
          )}
        </div>
      </div>
    </div>,
    document.body,
  );
}

